import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import {
  BehaviorSubject,
  Subject,
  debounceTime,
  fromEvent,
  takeUntil,
} from "rxjs";

export interface Menu {
  headTitle1?: string;
  level?: number;
  headTitle2?: string;
  path?: string;
  title?: string;
  type?: string;
  icon?: string;
  active?: boolean;
  roles?: string[];
  bookmark?: boolean;
  pinnedData?: boolean;
  items?: Menu[];
  children?: Menu[];
}

@Injectable({
  providedIn: "root",
})
export class NavService {
  public screenWidth: BehaviorSubject<number> = new BehaviorSubject(
    window.innerWidth,
  );

  private translationEntity = {
    "routes.dashboard": "",
    "routes.users": "",
    "routes.users_list": "",
    "routes.new_user": "",
    "routes.projects": "",
    "routes.projects_list": "",
    "routes.new_project": "",
    "routes.contracting_station": "",
    "routes.new_contracting_station": "",
    "routes.contracting_station_list": "",
    "routes.documents": "",
    "routes.documents_list": "",
  };

  private unSubscriber: Subject<any> = new Subject();

  public language: boolean = false;

  public collapseSidebar: boolean = window.innerWidth < 1200 ? true : false;

  MENUITEMS: Menu[] = [];
  items = new BehaviorSubject<Menu[]>(this.MENUITEMS);

  constructor(private translateService: TranslateService) {
    this.setScreenWidth(window.innerWidth);
    this.getTranslations();

    fromEvent(window, "resize")
      .pipe(debounceTime(0), takeUntil(this.unSubscriber))
      .subscribe((evt: any) => {
        this.setScreenWidth(evt.target.innerWidth);
        if (evt.target.innerWidth < 1200) {
          this.collapseSidebar = true;
        } else {
          this.collapseSidebar = false;
        }
      });
  }

  private setScreenWidth(width: number): void {
    this.screenWidth.next(width);
  }

  private getTranslations() {
    this.translateService
      .get(Object.keys(this.translationEntity))
      .subscribe((res) => {
        this.translationEntity = res;
        this.MENUITEMS = [
          {
            headTitle1: "Menu",
            roles: ["admin", "project_leader", "employee", "guest"],
          },
          {
            level: 1,
            path: "pages/dashboard",
            title: this.translationEntity["routes.dashboard"],
            icon: "home",
            type: "link",
            roles: ["admin", "project_leader", "employee", "guest"],
          },
          {
            level: 1,
            title: this.translationEntity["routes.users"],
            icon: "user",
            type: "sub",
            active: true,
            roles: ["admin"],
            children: [
              {
                path: "/anagrafiche/lista-utenti",
                title: this.translationEntity["routes.users_list"],
                type: "link",
                icon: "user",
                bookmark: true,
              },
              {
                path: "/anagrafiche/nuovo-utente",
                title: this.translationEntity["routes.new_user"],
                type: "link",
                icon: "sample-page",
                bookmark: true,
              },
            ],
          },
          {
            level: 1,
            title: this.translationEntity["routes.projects"],
            icon: "sample-page",
            type: "sub",
            active: false,
            roles: ["admin", "project_leader", "employee", "guest"],
            children: [
              {
                path: "/progetti/lista-progetti",
                title: this.translationEntity["routes.projects_list"],
                type: "link",
                icon: "sample-page",
                bookmark: true,
              },
              {
                path: "/progetti/selezione-progetto",
                title: this.translationEntity["routes.new_project"],
                type: "link",
                icon: "sample-page",
                bookmark: true,
              },
            ],
          },
          {
            level: 1,
            title: this.translationEntity["routes.contracting_station"],
            icon: "project",
            type: "sub",
            active: false,
            roles: ["admin"],
            children: [
              {
                path: "stazione-appaltante/lista-stazioni-appaltanti",
                title:
                  this.translationEntity["routes.contracting_station_list"],
                type: "link",
                icon: "",
                bookmark: true,
              },
              {
                path: "stazione-appaltante/nuova-stazione-appaltante",
                title: this.translationEntity["routes.new_contracting_station"],
                type: "link",
                icon: "",
                bookmark: true,
              },
            ],
          },
          {
            level: 1,
            title: this.translationEntity["routes.documents"],
            icon: "file",
            type: "sub",
            active: false,
            roles: ["admin", "project_leader", "employee", "guest"],
            children: [
              {
                path: "/documents/lista-documenti",
                title: this.translationEntity["routes.documents_list"],
                type: "link",
                icon: "",
                bookmark: true,
              },
            ],
          },
        ];

        this.items.next(this.MENUITEMS);
      });
  }

  ngOnDestroy() {
    this.unSubscriber.complete();
  }
}
